export default __webpack_public_path__ + "653710756ee6eb943a3d51cb94ef2ffd.png";